import type { TranslationFunctions } from '@i18n/i18n-types';
import { APP_NAME } from '@shared/constants';
import type { Competitor } from '@shared/route-types';
import { isAlternativeLandingPage, URLS } from '@shared/routing';

export async function getLogo($LL: TranslationFunctions, path: string): Promise<{ src: string; alt: string }> {
    if (isAlternativeLandingPage(path)) {
        const { getAlternativeLogo } = await import('@components/public/alternative/functions');
        const competitor = path.split('/').reverse()[0] as Competitor;
        return getAlternativeLogo($LL, competitor);
    }

    switch (path) {
        case URLS.talkToStrangers():
            return {
                src: '/images/landings/main-safe/random-video-chat-flirtify.svg',
                alt: `${APP_NAME} random video chat`,
            };
        default: {
            return {
                src: '/images/landings/main/sex-video-chat-flirtify-logo.svg',
                alt: `${APP_NAME} sex video chat`,
            };
        }
    }
}
